<script>
import SpellCheckedText from "@/components/SpellCheckedText.vue";
import PhotoBox from "../../PhotoBox.vue";

export default {
  name: "LPTemp2",
  components: {
    SpellCheckedText,
    PhotoBox
  },
  props: ["proposal"]
};
</script>

<template>
  <div class="main-container" :style="{
    '--header-color': proposal.style.colorScheme.header,
    '--body-color': proposal.style.colorScheme.body,
    '--footer-color': proposal.style.colorScheme.footer,
    '--heading-color': proposal.style.heading.color,
    '--heading-size': proposal.style.heading.size + 'px',
    '--heading-font': proposal.style.heading.font,
    '--heading-weight': proposal.style.heading.bold ? 'bold' : 'normal',
    '--heading-style': proposal.style.heading.italic ? 'italic' : 'normal',
    '--heading-decoration': proposal.style.heading.underline
      ? 'underline'
      : 'none',
    '--label-color': proposal.style.label.color,
    '--label-size': proposal.style.label.size + 'px',
    '--label-font': proposal.style.label.font,
    '--label-weight': proposal.style.label.bold ? 'bold' : 'normal',
    '--label-style': proposal.style.label.italic ? 'italic' : 'normal',
    '--label-decoration': proposal.style.label.underline
      ? 'underline'
      : 'none',
    '--text-color': proposal.style.text.color,
    '--text-size': proposal.style.text.size + 'px',
    '--text-font': proposal.style.text.font,
    '--text-weight': proposal.style.text.bold ? 'bold' : 'normal',
    '--text-style': proposal.style.text.italic ? 'italic' : 'normal',
    '--text-decoration': proposal.style.text.underline ? 'underline' : 'none',
  }">
    <div
      v-if="proposal.projects && proposal.projects.length > 0 && (proposal.projects[0].uploadedPhoto || proposal.projects[0].photoURL)"
      class="project-img-container photobox">
      <PhotoBox :project="proposal.projects[0]" :bgColor="proposal.style.colorScheme && proposal.style.colorScheme.body" position="top-center" />
    </div>
    <div class="info-sec">
      <h2>
        <SpellCheckedText :value="proposal.submittedBy || ''" @input="proposal.submittedBy = $event" />
      </h2>
      <p class="name">
        <SpellCheckedText :value="proposal.name || ''" @input="proposal.name = $event" />
      </p>
      <p>
        <SpellCheckedText :value="proposal.address || ''" @input="proposal.address = $event" />
      </p>
      <p>
        <SpellCheckedText :value="proposal.city || ''" @input="proposal.city = $event" />,
        <SpellCheckedText :value="proposal.stateProvince || ''" @input="proposal.stateProvince = $event" />
      </p>
      <p>
        <SpellCheckedText :value="proposal.contactNo || ''" @input="proposal.contactNo = $event" />
      </p>
      <p>
        <SpellCheckedText :value="proposal.email || ''" @input="proposal.email = $event" />
      </p>
      <p>
        <SpellCheckedText :value="proposal.website || ''" @input="proposal.website = $event" />
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.main-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 211mm;
  height: 296.83mm;
  min-height: 296.83mm;
  box-sizing: border-box;
  background: var(--body-color);

  &:hover {
    .photobox :deep(.photo-overlay) {
      opacity: 1;
    }

    .photobox :deep(img) {
      opacity: 0.9;
    }
  }

  .project-img-container {
    width: 100%;
    height: 100%;
    background: var(--body-color);
  }

  .info-sec {
    position: absolute;
    bottom: 300px;
    left: 0;
    z-index: 20;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: auto;
    text-align: center;
    text-shadow: 1px 1px 2px black;
    line-height: 1.2;

    h2 {
      margin: 0px 0px 15px 0px;
      color: var(--heading-color);
      font-size: var(--heading-size);
      font-family: var(--heading-font);
      font-weight: var(--heading-weight);
      font-style: var(--heading-style);
      text-decoration: var(--heading-decoration);
    }

    .name {
      color: var(--label-color);
      font-size: var(--label-size);
      font-family: var(--label-font);
      font-weight: var(--label-weight);
      font-style: var(--label-style);
      text-decoration: var(--label-decoration);
      margin-bottom: 5px;
    }

    p {
      margin: 0px;
      color: var(--text-color);
      font-size: var(--text-size);
      font-family: var(--text-font);
      font-weight: var(--text-weight);
      font-style: var(--text-style);
      text-decoration: var(--text-decoration);
    }
  }
}
</style>